import {
  CountryCodes,
  CurrencyCodes,
  Industry,
  LanguageCodes,
  VoiceLlm,
  VoiceStyle,
} from "Infrastructure/Api/Api";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";

export const DeutschResourcesDictionary: ResourceDictionary = {
  Common: {
    Admin: "Admin",
    AppName: "Vivelo.AI",
    ComingSoon: "Demnächst verfügbar",
    ComingSoonNote: "Der Inhalt wird in Kürze aktualisiert.",
    BackToSignIn: "Zurück zur Anmeldung",
    Years: "{{count}} Jahre",
    Years_one: "{{count}} Jahr",
    Years_two: "{{count}} Jahre",
    Years_few: "{{count}} Jahre",
    Years_other: "{{count}} Jahre",
    YearsLabel: "Jahre",
    YearsLabel_one: "Jahr",
    YearsLabel_few: "Jahre",
    YearsLabel_other: "Jahre",
    Month: "Monat",
    Months: "{{count}} Monate",
    Months_one: "{{count}} Monat",
    Months_two: "{{count}} Monate",
    Months_few: "{{count}} Monate",
    Months_other: "{{count}} Monate",
    Continue: "Weiter",
    Step: "SCHRITT {{actual}} VON {{count}}",
    TextCopied: "Text wurde in die Zwischenablage kopiert.",
    Yes: "Ja",
    No: "Nein",
    Choose: "Auswählen",
    Download: "Herunterladen",
    Upload: "Hochladen",
    Downloading: "Wird heruntergeladen",
    UnsupportedFileType: "Nicht unterstützter Dateityp",
    Email: "E-Mail",
    Password: "Passwort",
    ExampleLogin: "z.B. max.mustermann@email.de",
    PiecesShort: "{{count, number}} Stk.",
    PiecesSuffix: "Stk.",
    Active: "Aktiv",
    Inactive: "Inaktiv",
    Assigned: "Zugewiesen",
    Actual: "Aktuell",
    Blocked: "Gesperrt",
    Canceled: "Storniert",
    Cancel: "Abbrechen",
    Close: "Schließen",
    Confirm: "Bestätigen",
    Open: "Öffnen",
    Ended: "Beendet",
    All: "Alle",
    AllStatuses: "Alle Status",
    PrivacyPolicyLink: "Datenschutzrichtlinien.",
    Error:
      "Etwas ist schiefgelaufen. Wir entschuldigen uns für die Unannehmlichkeiten. Bitte versuchen Sie es später erneut.",
    Save: "Speichern",
    Search: "Suchen",
    Reset: "Zurücksetzen",
    WithTax: "inkl. MwSt.",
    WithoutTax: "exkl. MwSt.",
    Edit: "Bearbeiten",
    Back: "Zurück",
    BackToProjects: "Zurück zu Projekten",
    BackToProject: "Zurück zum Projekt",
    BackToDashboard: "Zurück zum Dashboard",
    BackToClients: "Zurück zu Kunden",
    BackToClient: "Zurück zum Kunden",
    BackToActors: "Zurück zu Sprechern",
    BackToPartners: "Zurück zu Partnern",
    BackToPartner: "Zurück zum Partner",
    StatusActive: "Aktiv",
    StatusInactive: "Inaktiv",
    Status: "Status",
    BackToModules: "Zurück zu Modulen",
    BackToModule: "Zurück zum Modul",
    BackToPriceCategories: "Zurück zu Preiskategorien",
    Delete: "Löschen",
    PreviousStep: "Vorheriger Schritt",
    SaveAndClose: "Speichern und schließen",
    SaveSuccess: "Erfolgreich gespeichert.",
    CompanyNumber: "Handelsregisternr.",
    TaxNumber: "USt-IdNr.",
    PersonalNumber: "Personalnr.",
    ProcessedByRepresentative: "Bearbeitet{{gender}} von {{name}}",
    SendByRepresentative: "Gesendet{{gender}} von {{name}}",
    SignOut: "Abmelden",
    Language: "Sprache",
    Users: "Benutzer",
    NewProject: "Neues Projekt",
    NewActor: "Neuer Sprecher",
    NewPartner: "Neuer Partner",
    NewModule: "Neues Modul",
    NewClient: "Neuer Kunde",
    Dashboard: "Dashboard",
    Projects: "Projekte",
    Actors: "Sprecher",
    Partners: "Partner",
    Modules: "Module",
    PriceCategories: "Preiskategorien",
    NewPriceCategory: "Neue Preiskategorie",
    Clients: "Kunden",
    MusicAudio: "Musik und Audio",
    Wallet: "Geldbörse",
    Invoices: "Rechnungen",
    WithdrawalApprovals: "Auszahlungen an Sprecher",
    RegistrationRequests: "Registrierungsanfragen",
    BackToWithdrawalApprovals: "Zurück zu Auszahlungen",
    BackToRegistrationRequests: "Zurück zu Registrierungsanfragen",
    ActivityLog: "Aktivitätsprotokoll",
    Reporting: "Berichte",
    GoodMorning: "Guten Morgen, {{name}}",
    StatusDone: "Erledigt",
    StatusClosed: "Geschlossen",
    StatusInProgress: "In Bearbeitung",
    StatusDraft: "Entwurf",
    StatusWaitingForApproval: "Wartet auf Genehmigung",
    StatusRejectedByActor: "Vom Sprecher abgelehnt",
    StatusAwaitingFunds: "Warten auf Mittel",
    NoItems: "Keine Einträge",
    Currency: "Währung",
    Currencies: {
      [CurrencyCodes.EUR]: "Euro (€)",
      [CurrencyCodes.USD]: "US-Dollar ($)",
      [CurrencyCodes.CZK]: "Tschechische Krone (Kč)",
      [CurrencyCodes.GBP]: "Britisches Pfund (£)",
      [CurrencyCodes.PLN]: "Polnischer Zloty (zł)",
      [CurrencyCodes.CHF]: "Schweizer Franken (CHF)",
      [CurrencyCodes.SEK]: "Schwedische Krone (kr)",
      [CurrencyCodes.NOK]: "Norwegische Krone (kr)",
      [CurrencyCodes.DKK]: "Dänische Krone (kr)",
      [CurrencyCodes.HUF]: "Ungarischer Forint (Ft)",
      [CurrencyCodes.RON]: "Rumänischer Leu (lei)",
    },
    Languages: {
      [LanguageCodes.Czech]: "Tschechisch",
      [LanguageCodes.English]: "Englisch",
      [LanguageCodes.Deutsch]: "Deutsch",
      [LanguageCodes.French]: "Französisch",
      [LanguageCodes.Italian]: "Italienisch",
      [LanguageCodes.Spanish]: "Spanisch",
      [LanguageCodes.Polish]: "Polnisch",
      [LanguageCodes.Dutch]: "Niederländisch",
      [LanguageCodes.Romanian]: "Rumänisch",
      [LanguageCodes.Hungarian]: "Ungarisch",
      [LanguageCodes.Portuguese]: "Portugiesisch",
      [LanguageCodes.Swedish]: "Schwedisch",
      [LanguageCodes.Bulgarian]: "Bulgarisch",
      [LanguageCodes.Danish]: "Dänisch",
      [LanguageCodes.Finnish]: "Finnisch",
      [LanguageCodes.Slovak]: "Slowakisch",
      [LanguageCodes.Croatian]: "Kroatisch",
      [LanguageCodes.Lithuanian]: "Litauisch",
      [LanguageCodes.Slovenian]: "Slowenisch",
      [LanguageCodes.Latvian]: "Lettisch",
      [LanguageCodes.Estonian]: "Estnisch",
      [LanguageCodes.Greek]: "Griechisch",
      [LanguageCodes.Maltese]: "Maltesisch",
      [LanguageCodes.Irish]: "Irisch",
    },
    Countries: {
      [CountryCodes.AT]: "Österreich",
      [CountryCodes.BE]: "Belgien",
      [CountryCodes.BG]: "Bulgarien",
      [CountryCodes.CY]: "Zypern",
      [CountryCodes.CZ]: "Tschechien",
      [CountryCodes.DE]: "Deutschland",
      [CountryCodes.DK]: "Dänemark",
      [CountryCodes.EE]: "Estland",
      [CountryCodes.ES]: "Spanien",
      [CountryCodes.FI]: "Finnland",
      [CountryCodes.FR]: "Frankreich",
      [CountryCodes.GR]: "Griechenland",
      [CountryCodes.HR]: "Kroatien",
      [CountryCodes.HU]: "Ungarn",
      [CountryCodes.IE]: "Irland",
      [CountryCodes.IT]: "Italien",
      [CountryCodes.LT]: "Litauen",
      [CountryCodes.LU]: "Luxemburg",
      [CountryCodes.LV]: "Lettland",
      [CountryCodes.MT]: "Malta",
      [CountryCodes.NL]: "Niederlande",
      [CountryCodes.PL]: "Polen",
      [CountryCodes.PT]: "Portugal",
      [CountryCodes.RO]: "Rumänien",
      [CountryCodes.SE]: "Schweden",
      [CountryCodes.SI]: "Slowenien",
      [CountryCodes.SK]: "Slowakei",
    },
    Industries: {
      [Industry.Retail]: "Einzelhandel",
      [Industry.Finance]: "Finanzen",
      [Industry.Automotive]: "Automobilindustrie",
      [Industry.Ecommerce]: "E-Commerce",
      [Industry.EnergyAndUtilities]: "Energie & Versorgung",
      [Industry.Pharmaceuticals]: "Pharmaindustrie",
      [Industry.Gaming]: "Spiele",
      [Industry.LogisticsAndTransport]: "Logistik & Transport",
      [Industry.MediaAndEntertainment]: "Medien & Unterhaltung",
      [Industry.FashionAndLifestyle]: "Mode & Lifestyle",
      [Industry.RealEstate]: "Immobilien",
      [Industry.NonProfit]: "Gemeinnütziger Sektor",
      [Industry.HospitalityAndTourism]: "Gastgewerbe & Tourismus",
      [Industry.Insurance]: "Versicherungswesen",
      [Industry.FoodAndGastronomy]: "Lebensmittel & Gastronomie",
      [Industry.LegalServices]: "Rechtsdienstleistungen",
      [Industry.AdvertisingAndMarketing]: "Werbung & Marketing",
      [Industry.SportsAndFitness]: "Sport & Fitness",
      [Industry.TechnologyAndIT]: "Technologie & IT",
      [Industry.Telecommunications]: "Telekommunikation",
      [Industry.PublicSector]: "Öffentlicher Sektor",
      [Industry.Education]: "Bildung",
      [Industry.Healthcare]: "Gesundheitswesen",
      [Industry.Other]: "Sonstige",
    },
    VoiceLlms: {
      [VoiceLlm.ElevenLabs_V3]: "ElevenLabs V3",
      [VoiceLlm.ElevenLabs_V2]: "ElevenLabs V2",
      [VoiceLlm.MicrosoftTts]: "Microsoft TTS",
      [VoiceLlm.AiVoice]: "AIVoice",
    },
    VoiceStyles: {
      [VoiceStyle.Neutral]: "Neutral",
      [VoiceStyle.Cheerful]: "Fröhlich",
      [VoiceStyle.Excited]: "Begeistert",
      [VoiceStyle.Friendly]: "Freundlich",
      [VoiceStyle.Sad]: "Traurig",
      [VoiceStyle.Angry]: "Wütend",
      [VoiceStyle.Calm]: "Ruhig",
      [VoiceStyle.Newscast]: "Nachrichtenstil",
      [VoiceStyle.Whispering]: "Flüsternd",
      [VoiceStyle.Authoritative]: "Autoritär",
      [VoiceStyle.Empathetic]: "Einfühlsam",
    },
  },
  JobDetail: {
    SelectLanguageModelPlaceholder: "Sprachmodell auswählen",
    InstructionsPlaceholder: "Anweisungen für die Texterstellung eingeben...",
    PrepareYourVoicelines: "Skript des Sprecherspots",
    GeneratePreview: "Vorschau generieren",
    GenerateFullVoiceover: "Gesamten Spot generieren",
    VoicelinesMustBeFilledFirst: "Der Text muss zuerst ausgefüllt werden",
    FailedToGeneratePreview: "Vorschau konnte nicht generiert werden",
    FailedToGenerateClip: "Spot konnte nicht generiert werden",
    GeneralSettingsTab: "Allgemeine Einstellungen",
    ParametersTab: "Parameter",
    FinalizeTab: "Generierte Ausgaben",
    SegmentSettingsTab: "Segmenteinstellungen",
    BackgroundMusic: "Hintergrundmusik",
    NoMusic: "Ohne Musik",
    SelectBackgroundMusic: "Hintergrundmusik auswählen",
    SelectFinalClip: "Finalen Clip auswählen",
    AlreadyFinalized: "Dieser Job wurde bereits finalisiert.",
    FinalClipReady: "Der finale Clip ist bereit.",
    DownloadFinalClip: "Finalen Clip herunterladen",
    Clip: "Spot",
    ClipPreview: "Vorschau",
    FinalizeConfirm: "Finalisieren",
    FinalizeSuccess: "Job wurde erfolgreich finalisiert",
    FinalizeError: "Job konnte nicht finalisiert werden",
    FinalizeInsufficientBalance:
      "Das Guthaben reicht nicht aus, um diesen Job zu bezahlen",
    DefaultVoiceModel: "Standard-Sprachmodell",
    GlobalLanguage: "Globale Sprache",
    Language: "Sprache",
    GlobalSpeed: "Globale Geschwindigkeit",
    GlobalVolume: "Globale Lautstärke",
    CostLimit: "Kostenlimit",
    Variables: "Variablen",
    AddVariable: "Variable hinzufügen",
    // Script editor
    SegmentText: "Text",
    VoiceSegmentHeading: "Stimme",
    PauseSegmentHeading: "Pause",
    AddVoiceSegment: "Stimme hinzufügen",
    AddPause: "Pause hinzufügen",
    AddBackgroundAudio: "Medien hinzufügen",
    DeleteSegment: "Segment löschen",
    NoSegmentSelected: "Wählen Sie ein Segment im Editor aus",
    SelectVoiceModel: "Sprachmodell auswählen",
    Emotion: "Emotion",
    EmotionAndReactions: "Emotion und Reaktionen",
    SpeedFactor: "Geschwindigkeit",
    VolumePercent: "Lautstärke",
    PauseDuration: "Pausendauer",
    Seconds: "s",
    VariableName: "Variablenname",
    VariableDefaultValue: "Standardwert",
    AddVariableDialogTitle: "Variable hinzufügen",
    AddVariableDialogConfirm: "Hinzufügen",
    DeleteVariable: "Variable löschen",
    ScriptErrors:
      "Das Skript enthält {{count}} Fehler, bitte beheben Sie diese vor dem Speichern.",
    SegmentEmptyText: "Segment enthält keinen Text",
    SegmentNoActor: "Wählen Sie einen Sprecher für dieses Segment",
    SegmentNoFile: "Wählen Sie eine Datei für dieses Segment",
    SegmentZeroDuration: "Die Pausendauer muss größer als 0 sein",
    SegmentInvalidStartTime: "Die Startzeit muss eine positive Zahl sein",
    SegmentInvalidSpeedFactor:
      "Die Geschwindigkeit muss zwischen 0,5× und 2,0× liegen",
    EmptyScript: "Das Skript enthält keine Segmente",
    SaveScript: "Speichern",
    SaveScriptSuccess: "Skript wurde erfolgreich gespeichert",
    SaveScriptError: "Skript konnte nicht gespeichert werden",
    ExpectedPrice: "Voraussichtlicher Preis",
    ExpectedLength: "Geschätzte Länge",
    SelectActorFirst: "Bitte wählen Sie zuerst einen Sprecher",
    AddSegmentTooltip: "Segment hinzufügen",
    RemoveEmotion: "Ohne Emotion",
    // AI integration
    AiRefinementTitle: "Bearbeitung mit KI",
    AiTab: "KI",
    AiDraftTitle: "KI-Textentwurf",
    AiDraftDescription:
      "Geben Sie Anweisungen ein und die KI erstellt einen Voiceover-Textentwurf. Sie können den Text weiter bearbeiten und dann in ein Skript umwandeln.",
    ConvertToScript: "In Skript umwandeln",
    ConvertToVoiceSegments: "In Sprachsegmente umwandeln",
    CopyToClipboard: "In Zwischenablage kopieren",
    SkipToManualEdit: "Überspringen, manuell schreiben",
    BackToQuestionnaire: "Zurück zu den Fragen",
    RegenerateFromQuestionnaire: "Neu generieren",
    BackToAiDraft: "Zurück zum KI-Entwurf und Fragen",
    WorkingArtifact: "Arbeitsartefakt",
    AiDraftEmptyState:
      "Geben Sie Anweisungen ein und die KI hilft Ihnen, eine erste Textversion zu erstellen.",
    AiArtifactEmptyState:
      "Geben Sie Anweisungen zur Skriptbearbeitung ein. Vorschläge der KI werden hier angezeigt und können mit einem Klick in das Skript eingefügt werden.",
    AddToScript: "Zum Skript hinzufügen",
    JobNotFound: "Job wurde nicht gefunden",
    AudioFormat: "Audioformat",
    SampleRate: "Abtastrate",
    Bitrate: "Bitrate",
    AudioChannels: "Kanäle",
    ScriptEditorEmptyState:
      "Fügen Sie das erste Segment über die Schaltflächen oben hinzu",
    DeletePause: "Pause löschen",
    DeleteMedia: "Medium löschen",
    JobReadOnlyBanner:
      "Dieser Job ist gesperrt und kann nicht bearbeitet werden.",
    AddVariableTooltip:
      "Fügt eine Variable an der Cursorposition ein / umschließt die Auswahl",
    DefaultVariableName: "neue_variable",
    MediaStartAt: "Wiedergabestart",
    MediaDuration: "Wiedergabedauer",
    ClipPrice: "Clip-Preis",
    AwaitingFundsMessage:
      "Alle Sprecher haben zugestimmt, aber das Guthaben reicht nicht für die Finalisierung. Bitte laden Sie Guthaben auf und versuchen Sie es erneut.",
    RetryFinalization: "Finalisierung wiederholen",
    RetryFinalizationSuccess: "Job wurde erfolgreich finalisiert",
    RetryFinalizationError: "Job konnte nicht finalisiert werden",
    Activate: "Aktivieren",
    Deactivate: "Deaktivieren",
    ActivateSuccess: "Job wurde erfolgreich aktiviert",
    DeactivateSuccess: "Job wurde erfolgreich deaktiviert",
    StatusChangeError: "Status des Jobs konnte nicht geändert werden",
    AddReaction: "Reaktion hinzufügen",
    AddReactionTooltip:
      "Fügen Sie eine Reaktion (Lachen, Flüstern, …) an der Cursorposition ein. Nur für ElevenLabs v3 verfügbar.",
    ReactionOnlyV3Hint:
      "Reaktionen werden nur von ElevenLabs v3-Stimmen unterstützt; andere Modelle ignorieren sie.",
    Reaction: {
      Heading: "Reaktion",
      CategoryReactions: "Reaktionen",
      CategoryVolumeEnergy: "Lautstärke & Energie",
      CategoryPacing: "Tempo & Rhythmus",
      Custom: "Benutzerdefiniert",
      CustomPlaceholder: "z. B. angry english accent",
      RemoveReaction: "Reaktion entfernen",
      EditReaction: "Reaktion bearbeiten",
      Values: {
        Gasp: "Nach Luft schnappen",
        Sigh: "Seufzen",
        Laughs: "Lachen",
        Gulps: "Schlucken",
        Crying: "Weinen",
        EvilLaugh: "Böses Lachen",
        Hums: "Summen",
        Giggle: "Kichern",
        Whispering: "Flüstern",
        Shouting: "Schreien",
        Quietly: "Leise",
        Loudly: "Laut",
        Sings: "Singen",
        Sarcastic: "Sarkastisch",
        Stammers: "Stottern",
        Rushed: "Hastig",
      },
    },
    Wizard: {
      StepQuestionnaire: "Fragen",
      StepAiDraft: "KI-Entwurf",
      StepScriptEditor: "Skript-Editor",
    },
    ChoiceScreen: {
      Title: "Wie möchten Sie beginnen?",
      Description:
        "Wählen Sie, wie Sie den Voiceover-Entwurf erstellen möchten.",
      AnswerQuestionsTitle: "Fragen beantworten",
      AnswerQuestionsDescription:
        "Beantworten Sie vorbereitete Fragen und der Text wird automatisch basierend auf Ihren Antworten generiert.",
      OwnPromptTitle: "Eigene Anweisungen eingeben",
      OwnPromptDescription:
        "Überspringen Sie die Fragen und geben Sie Ihre eigenen Anweisungen für die KI direkt ein.",
    },
    Questionnaire: {
      Title: "Fragen beantworten",
      Description:
        "Beantworten Sie die folgenden Fragen. Ein Textentwurf wird basierend auf Ihren Antworten generiert.",
      Generate: "Entwurf generieren",
      Continue: "Weiter",
      Skip: "Überspringen",
      EditAnswers: "Antworten bearbeiten",
      OtherOption: "Andere",
      AnswersSaved: "Antworten gespeichert.",
      Back: "Zurück",
      GeneratingDraft: "Textentwurf wird generiert...",
    },
  },
  Dashboard: {
    CreateNewProject: "Neues Projekt erstellen",
    RecentProjects: "Letzte Projekte",
    SingleActorVoiceMax60s: "Ein Sprecher – max. 60 Sekunden",
    ProjectName: "Projektname",
    Client: "Kunde",
    License: "Lizenz",
    Jobs: "Jobs",
    Budget: "Budget",
    Expense: "Ausgaben",
    Status: "Status",
    SearchProjects: "Projekte suchen",
    SearchProjectsPlaceholder: "Projektname, Kunde...",
    AllClients: "Alle Kunden",
    AllStatuses: "Alle Status",
    Active: "Aktiv",
    Completed: "Abgeschlossen",
    Pending: "Ausstehend",
    ReportingOverview: "Berichtsübersicht",
    ViewFullReport: "Vollständigen Bericht anzeigen",
    PendingWithdrawals: "Ausstehende Auszahlungsanfragen",
    NoPendingWithdrawals: "Keine ausstehenden Auszahlungsanfragen.",
    ViewAllWithdrawals: "Alle Auszahlungen anzeigen",
  },
  ActivityLog: {
    Title: "Aktivitätsprotokoll",
    Timestamp: "Zeit",
    User: "Benutzer",
    Event: "Ereignis",
    Note: "Notiz",
    Detail: "Detail",
    AllEventTypes: "Alle Ereignisse",
    DateFrom: "Datum von",
    DateTo: "Datum bis",
    NoActivities: "Keine Aktivitäten anzuzeigen",
    ActorCreated: "Schauspieler erstellt",
    ActorPriceCategoryChanged: "Preiskategorie des Schauspielers geändert",
    PartnerCreated: "Partner erstellt",
    ProjectCreated: "Projekt erstellt",
    ProjectCompleted: "Projekt abgeschlossen",
    ProjectClosed: "Projekt geschlossen",
    JobCompleted: "Job abgeschlossen",
    PartnerCreditTopUp: "Partner-Guthaben aufgeladen",
    ActorPayoutApproved: "Auszahlung an Schauspieler genehmigt",
    ClientCreated: "Kunde erstellt",
  },
  Projects: {
    DefaultLanguageOption: "Standard (Sprache des Sprechers)",
    CreateProjectModal: {
      Title: "Neues Projekt erstellen",
      SelectModule: "Modul auswählen",
      SelectModulePlaceholder: "Modul auswählen",
      Client: "Kunde",
      SelectClientPlaceholder: "Kunde auswählen",
      Name: "Name",
      NamePlaceholder: "Projektname eingeben",
      Industry: "Branche",
      SelectIndustryPlaceholder: "Branche auswählen",
      Language: "Sprache",
      SelectLanguagePlaceholder: "Sprache auswählen",
      LicensedCountries: "Lizenzierte Länder",
      SelectLicensedCountriesPlaceholder: "Lizenzierte Länder auswählen",
      JobsLimit: "Auftragslimit",
      JobsLimitPlaceholder: "Maximale Auftragsanzahl eingeben",
      AmountLimit: "Betragslimit",
      AmountLimitPlaceholder: "Maximalen Betrag eingeben",
      StartDate: "Startdatum",
      EndDate: "Enddatum",
      ProjectState: "Projektstatus",
      ProjectStatePlaceholder: "Projektstatus auswählen",
      Create: "Erstellen",
      SuccessMessage: "Projekt wurde erfolgreich erstellt",
      ErrorMessage: "Projekt konnte nicht erstellt werden",
      HasExclusiveContracts:
        "Ich habe einen Exklusivvertrag mit dem/den Sprecher(n)",
      ContractedActor: "Vertragssprecher",
      ContractPrice: "Vertragspreis",
      ContractJobsLimit: "Auftragslimit des Vertrags",
      AddExclusiveContract: "Weiteren Exklusivvertrag hinzufügen",
    },
    EditProjectModal: {
      Title: "Projekt bearbeiten",
      Edit: "Speichern",
      SuccessMessage: "Projekt wurde erfolgreich aktualisiert",
      ErrorMessage: "Projekt konnte nicht aktualisiert werden",
    },
    CreateJobModal: {
      Title: "Neuen Job erstellen",
      Name: "Name",
      NamePlaceholder: "Jobname eingeben",
      Create: "Erstellen",
      SuccessMessage: "Job wurde erfolgreich erstellt",
      ErrorMessage: "Job konnte nicht erstellt werden",
    },
    ProjectActorsModal: {
      Title: "Sprecher zum Projekt hinzufügen",
      Approve: "Genehmigen",
      SuccessMessage: "Sprecherliste erfolgreich aktualisiert",
      ErrorMessage: "Sprecherliste konnte nicht aktualisiert werden",
      CannotRemoveActorWithActiveJobs:
        "Sprecher mit abgeschlossenen oder ausstehenden Jobs kann nicht entfernt werden.",
    },
    ProjectDetail: {
      Information: "Informationen",
      EditInformation: "Informationen bearbeiten",
      Industry: "Branche",
      Client: "Kunde",
      Language: "Sprache",
      LicenceForStates: "Lizenz für Länder",
      JobsLimit: "Auftragslimit",
      CurrentJobs: "Aktuelle Jobs",
      StartDate: "Startdatum",
      EndDate: "Enddatum",
      Jobs: "Jobs",
      AddJobToProject: "Neuer Job",
      JobsLimitExceeded: "Auftragslimit wurde erreicht",
      JobLocked: "Job ist gesperrt",
      Actors: "Sprecher",
      Actor: "Sprecher",
      AddActorToProject: "Sprecher zum Projekt hinzufügen",
      CloseProject: "Projekt beenden",
      FinishProject: "Projekt abschließen",
      CloseProjectConfirmTitle: "Projekt beenden",
      CloseProjectConfirmContent:
        "Möchten Sie das Projekt wirklich beenden? Diese Aktion kann nicht rückgängig gemacht werden.",
      FinishProjectConfirmTitle: "Projekt abschließen",
      FinishProjectConfirmContent:
        "Möchten Sie das Projekt wirklich als abgeschlossen markieren? Diese Aktion kann nicht rückgängig gemacht werden.",
      DocumentsAndInvoices: "Dokumente und Rechnungen",
      NoDocumentsYet: "Noch keine Dokumente vorhanden",
      ProjectNotFound: "Projekt wurde nicht gefunden",
      ProjectAmendment: "Projektänderung",
      CannotChangeActorBlocked:
        "Sprecher kann nicht geändert werden — es gibt abgeschlossene Jobs",
      ExclusiveContract: "Exklusivvertrag",
    },
  },
  Actors: {
    Name: "Name",
    ActorName: "Sprechername",
    NativeLanguage: "Muttersprache",
    Age: "Alter",
    Sex: "Geschlecht",
    PricePerModule: "Preis/Modul",
    AllLanguages: "Alle Sprachen",
    AllAges: "Alle Altersgruppen",
    AllSexes: "Alle Geschlechter",
    AllPrices: "Alle Preise",
    Male: "Männlich",
    Female: "Weiblich",
    CreateActorModal: {
      Title: "Neuer Sprecher",
      FirstName: "Vorname",
      FirstNamePlaceholder: "Vorname eingeben",
      LastName: "Nachname",
      LastNamePlaceholder: "Nachname eingeben",
      Email: "E-Mail",
      EmailPlaceholder: "E-Mail eingeben",
      Phone: "Telefon",
      PhonePlaceholder: "Telefonnummer eingeben",
      DateOfBirth: "Geburtsdatum",
      Gender: "Geschlecht",
      GenderPlaceholder: "Geschlecht auswählen",
      Language: "Muttersprache",
      LanguagePlaceholder: "Sprache auswählen",
      Industry: "Branche",
      IndustryPlaceholder: "Branche auswählen",
      Address: "Adresse",
      AddressPlaceholder: "Adresse eingeben",
      City: "Stadt",
      CityPlaceholder: "Stadt eingeben",
      PostalCode: "PLZ",
      PostalCodePlaceholder: "PLZ eingeben",
      Country: "Land",
      CountryPlaceholder: "Land auswählen",
      IBAN: "IBAN",
      IBANPlaceholder: "IBAN eingeben",
      SWIFT: "SWIFT/BIC",
      SWIFTPlaceholder: "SWIFT/BIC eingeben",
      Invoicing: "Rechnungsdaten (Selbstständige, Firma, Agentur)",
      BusinessName: "Firmenname",
      BusinessNamePlaceholder: "Firmenname eingeben",
      CompanyNumber: "Handelsregisternr.",
      CompanyNumberPlaceholder: "Handelsregisternr. eingeben",
      TaxNumber: "USt-IdNr.",
      TaxNumberPlaceholder: "USt-IdNr. eingeben",
      BillingAddress: "Adresse",
      BillingAddressPlaceholder: "Rechnungsadresse eingeben",
      BillingCity: "Stadt",
      BillingCityPlaceholder: "Stadt eingeben",
      BillingPostalCode: "PLZ",
      BillingPostalCodePlaceholder: "PLZ eingeben",
      BillingCountry: "Land",
      BillingCountryPlaceholder: "Land auswählen",
      BillingIBAN: "IBAN",
      BillingIBANPlaceholder: "IBAN eingeben",
      BillingSWIFT: "SWIFT/BIC",
      BillingSWIFTPlaceholder: "SWIFT/BIC eingeben",
      Create: "Erstellen",
      SuccessMessage: "Sprecher wurde erfolgreich erstellt",
      ErrorMessage: "Sprecher konnte nicht erstellt werden",
    },
    EditActorModal: {
      Title: "Sprecher bearbeiten",
      Save: "Speichern",
      SuccessMessage: "Sprecher wurde erfolgreich aktualisiert",
      ErrorMessage: "Sprecher konnte nicht aktualisiert werden",
    },
    ProfilePicture: {
      UploadPhoto: "Profilbild hochladen",
      ChangePhoto: "Profilbild ändern",
      DeletePhoto: "Foto löschen",
      CropTitle: "Profilbild bearbeiten",
      Zoom: "Zoom",
      UploadError: "Profilbild konnte nicht hochgeladen werden",
      DeleteError: "Profilbild konnte nicht gelöscht werden",
    },
    ActorDetail: {
      Information: "Informationen",
      EditInformation: "Informationen bearbeiten",
      Email: "E-Mail",
      Phone: "Telefon",
      DateOfBirth: "Geburtsdatum",
      Gender: "Geschlecht",
      NativeLanguage: "Muttersprache",
      Industry: "Branche",
      Address: "Adresse",
      City: "Stadt",
      PostalCode: "PLZ",
      State: "Land",
      IBAN: "IBAN",
      SWIFT: "SWIFT/BIC",
      BusinessName: "Firmenname",
      CompanyNumber: "Handelsregisternr.",
      TaxNumber: "USt-IdNr.",
      BusinessAddress: "Rechnungsadresse",
      BillingIBAN: "IBAN (Rechnung)",
      BillingSWIFT: "SWIFT/BIC (Rechnung)",
      BackToActors: "Zurück zu Sprechern",
      NotFound: "Sprecher wurde nicht gefunden",
      Activate: "Aktivieren",
      Deactivate: "Deaktivieren",
      ActivateSuccess: "Sprecher wurde erfolgreich aktiviert",
      DeactivateSuccess: "Sprecher wurde erfolgreich deaktiviert",
      StatusChangeError: "Status des Sprechers konnte nicht geändert werden",
      VoiceActivateSuccess: "Stimme wurde erfolgreich aktiviert",
      VoiceDeactivateSuccess: "Stimme wurde erfolgreich deaktiviert",
      Voices: "Stimmen",
      Videos: "Videos",
      Transactions: "Transaktionen",
      TrainedVoices: "Trainierte Stimmen",
      NewVoice: "Neue Stimme",
      VoiceModuleRates: "Stimmmodul-Tarife",
      UpdateRates: "Tarife bearbeiten",
      NoRatesConfigured: "Keine Tarife konfiguriert",
      ContractsAndAmendments: "Verträge und Nachträge",
      NewAmendment: "Neuer Nachtrag",
      ProjectAmendments: "Projektnachträge",
      PriceCategories: {
        PricingModel: "Preismodell",
        ActorsCut: "Sprecherhonorar",
        DefaultPriceTooltip: "Standardpreis",
        Commission: "Provision",
        FinalPrice: "Endpreis",
        Notes: "Anmerkungen",
        State: "Status",
        Approval: "Genehmigung",
        NotSet: "-",
        SaveAmendment: {
          SuccessMessage: "Tarife wurden erfolgreich gespeichert",
          ErrorMessage: "Tarife konnten nicht gespeichert werden",
        },
      },
      NoTrainedVoices: "Noch keine trainierten Stimmen",
      Trained: "Trainiert",
      VoiceName: "Stimmname",
      Tags: "Tags",
      VoiceTraining: "Stimmtraining",
      TrainingModel: "Trainingsmodell",
      TrainingType: "Trainingstyp",
      ExternalVoiceID: "Externe Stimm-ID",
      ModelID: "Modell-ID",
      UploadTrainingData: "Trainingsdaten hochladen",
      Files: "Dateien",
      RemoveAllFiles: "Alle Dateien entfernen",
      SearchExternalVoice: "Externe Stimme suchen",
      ContinueToEditAndPreview: "Weiter zur Bearbeitung und Vorschau",
      UploadFilesRequired:
        "Zum Fortfahren muss mindestens eine Trainingsdatei hochgeladen werden",
      DemoPreview: "Demo-Vorschau",
      Speed: "Geschwindigkeit",
      Volume: "Lautstärke",
      GeneratePreview: "Vorschau generieren",
      StartTraining: "Training starten",
      VoiceStatus: {
        Draft: "Entwurf",
        UploadingTrainingFiles: "Dateien werden hochgeladen",
        TrainingInProcess: "Training läuft",
        TrainingCompleted: "Training abgeschlossen",
        TrainingFailed: "Training fehlgeschlagen",
        TrainingVerificationRequired: "Verifizierung erforderlich",
        Active: "Aktiv",
        Inactive: "Inaktiv",
      },
      VoiceTrainingTypes: {
        ElevenLabs_Instant: "ElevenLabs Instant",
        ElevenLabs_Professional: "ElevenLabs Professional",
      },
      NewVoiceModal: {
        Title: "Neue Stimme",
        Create: "Erstellen",
        SuccessMessage: "Stimme wurde erfolgreich erstellt",
        ErrorMessage: "Stimme konnte nicht erstellt werden",
      },
      EditVoiceModal: {
        Title: "Stimme bearbeiten",
        Save: "Speichern",
        SuccessMessage: "Stimme wurde erfolgreich aktualisiert",
        ErrorMessage: "Stimme konnte nicht aktualisiert werden",
      },
      GeneratePreviewError: {
        General: "Vorschau konnte nicht generiert werden",
        WrongStatus: "Die Stimme muss zuerst trainiert werden",
      },
      OpenToCollaboration: "Offen für Zusammenarbeit",
      NotOpenToCollaboration: "Kein Interesse an Zusammenarbeit",
    },
    ActorPriceCategoryStatus: {
      Allowed: "Erlaubt",
      NotAllowed: "Nicht erlaubt",
      Exclusive: "Exklusiv",
    },
    ActorPriceCategoryApprovalType: {
      Automatic: "Automatisch",
      Manual: "Manuell",
    },
  },
  Partners: {
    PartnerName: "Partnername",
    Projects: "Projekte",
    Email: "E-Mail",
    Phone: "Telefon",
    SearchPartnersPlaceholder: "Partnername",
    AddSubPartnerButton: "Unterpartner hinzufügen",
    CreatePartnerModal: {
      Title: "Neuen Partner erstellen",
      BusinessName: "Firmenname",
      BusinessNamePlaceholder: "Firmenname eingeben",
      SuperiorPartner: "Übergeordneter Partner",
      SuperiorPartnerPlaceholder: "Übergeordneten Partner auswählen",
      IdentificationNumber: "Handelsregisternr.",
      IdentificationNumberPlaceholder: "Handelsregisternr. eingeben",
      VAT: "USt-IdNr.",
      VATPlaceholder: "USt-IdNr. eingeben",
      Email: "E-Mail",
      EmailPlaceholder: "E-Mail eingeben",
      Phone: "Telefon",
      PhonePlaceholder: "Telefonnummer eingeben",
      Address: "Adresse",
      AddressPlaceholder: "Adresse eingeben",
      City: "Stadt",
      CityPlaceholder: "Stadt eingeben",
      PostalCode: "PLZ",
      PostalCodePlaceholder: "PLZ eingeben (z.B. 12345)",
      Country: "Land",
      CountryPlaceholder: "Land auswählen",
      Create: "Erstellen",
      AllowRetroactivePayment:
        "Partner rückwirkende Rechnungsbegleichung erlauben",
      SuccessMessage: "Partner wurde erfolgreich erstellt",
      ErrorMessage: "Partner konnte nicht erstellt werden",
    },
    PartnerDetail: {
      Information: "Informationen",
      EditInformation: "Informationen bearbeiten",
      CompanyNumber: "Handelsregisternr.",
      TaxNumber: "USt-IdNr.",
      Email: "E-Mail",
      Phone: "Telefon",
      Address: "Adresse",
      City: "Stadt",
      PostalCode: "PLZ",
      State: "Land",
      Projects: "Projekte",
      NoProjects: "Keine Projekte",
      Contracts: "Verträge",
      NoContracts: "Keine Verträge",
      ParentPartner: "Übergeordneter Partner",
      BackToPartners: "Zurück zu Partnern",
      AvailableModules: "Verfügbare Module",
      NoModules: "Keine Module",
      EditAvailableModules: "Verfügbare Module bearbeiten",
      Clients: "Kunden",
      NoClients: "Keine Kunden",
      Activate: "Aktivieren",
      Deactivate: "Deaktivieren",
      ActivateSuccess: "Partner wurde erfolgreich aktiviert",
      DeactivateSuccess: "Partner wurde erfolgreich deaktiviert",
      StatusChangeError: "Status des Partners konnte nicht geändert werden",
    },
    EditAvailableModulesModal: {
      Title: "Verfügbare Module bearbeiten",
      SearchPlaceholder: "Modul suchen",
      ModuleName: "Modulname",
      BaseModule: "Basismodul",
      Save: "Speichern",
      SuccessMessage: "Verfügbare Module wurden erfolgreich aktualisiert",
      ErrorMessage: "Verfügbare Module konnten nicht aktualisiert werden",
    },
    EditPartnerModal: {
      Title: "Partner bearbeiten",
      Save: "Speichern",
      SuccessMessage: "Partner wurde erfolgreich aktualisiert",
      ErrorMessage: "Partner konnte nicht aktualisiert werden",
    },
  },
  Modules: {
    ModuleBase: "Modultyp",
    ModuleName: "Modulname",
    Projects: "Projekte",
    LastUpdated: "Letzte Aktualisierung",
    Availability: "Verfügbarkeit",
    SearchModulesPlaceholder: "Modulname",
    AvailabilityActive: "Aktiv",
    AvailabilityInactive: "Inaktiv",
    CreateModuleModal: {
      Title: "Neues Modul erstellen",
      Name: "Name",
      NamePlaceholder: "Modulname eingeben",
      Type: "Modultyp",
      TypePlaceholder: "Modultyp auswählen",
      PriceCategory: "Preismodell",
      PriceCategoryPlaceholder: "Preismodell auswählen",
      CustomPrompt: "Benutzerdefinierter Prompt",
      CustomPromptPlaceholder:
        "Benutzerdefinierten Prompt für das Modul eingeben",
      TextLlmsSection: "Textmodell-Konfiguration:",
      VoiceLlmsSection: "Sprachmodell-Konfiguration:",
      Create: "Erstellen",
      SuccessMessage: "Modul wurde erfolgreich erstellt",
      ErrorMessage: "Modul konnte nicht erstellt werden",
    },
    ModuleTypes: {
      SingleVoiceSpot: "Einzelstimmen-Spot",
      MultiVoiceSpot: "Mehrstimmen-Spot",
    },
    TextLlms: {
      OpenAI_ChatGpt5: "OpenAI ChatGPT 5",
    },
    VoiceLlms: {
      ElevenLabs_V3: "ElevenLabs V3",
      ElevenLabs_V2: "ElevenLabs V2",
      MicrosoftTts: "Microsoft TTS",
    },
    ModuleDetail: {
      BackToModules: "Zurück zu Modulen",
      Information: "Modulinformationen",
      EditInformation: "Informationen bearbeiten",
      ModuleName: "Modulname",
      ModuleType: "Modultyp",
      Status: "Status",
      PriceCategory: "Preismodell",
      TextModels: "Textmodelle",
      VoiceModels: "Sprachmodelle",
      CustomPromptSection: "Benutzerdefinierter Prompt",
      NotFound: "Modul wurde nicht gefunden",
      Activate: "Aktivieren",
      Deactivate: "Deaktivieren",
      ActivateSuccess: "Modul wurde erfolgreich aktiviert",
      DeactivateSuccess: "Modul wurde erfolgreich deaktiviert",
      StatusChangeError: "Modulstatus konnte nicht geändert werden",
      AvailablePartners: "Verfügbar für",
      NoPartners: "Keine Partner",
      EditAvailablePartners: "Partner bearbeiten",
    },
    EditModuleModal: {
      Title: "Modul bearbeiten",
      Save: "Speichern",
      SuccessMessage: "Modul wurde erfolgreich aktualisiert",
      ErrorMessage: "Modul konnte nicht aktualisiert werden",
    },
    EditAvailablePartnersModal: {
      Title: "Verfügbare Partner",
      SearchPlaceholder: "Partner suchen...",
      PartnerName: "Partner",
      Save: "Speichern",
      SuccessMessage: "Partner wurden erfolgreich gespeichert",
      ErrorMessage: "Partner konnten nicht gespeichert werden",
    },
    Questions: {
      Title: "Modulfragen",
      EditQuestions: "Fragen bearbeiten",
      NoQuestions: "Keine Fragen konfiguriert",
      AddQuestion: "Frage hinzufügen",
      RemoveQuestion: "Frage entfernen",
      QuestionText: "Fragetext",
      QuestionTextPlaceholder: "Fragetext eingeben...",
      QuestionType: "Fragetyp",
      Required: "Pflicht",
      Options: "Optionen",
      AddOption: "Option hinzufügen",
      RemoveOption: "Option entfernen",
      OptionTextPlaceholder: "Optionstext...",
      SaveSuccess: "Modulfragen erfolgreich gespeichert.",
      OtherOptionLabel: "Andere (Textantwort)",
      ValidationQuestionTextRequired: "Fragentext eingeben.",
      ValidationOptionTextRequired: "Optionstext eingeben.",
      ValidationOptionsRequired: "Fügen Sie mindestens eine Option hinzu.",
      Types: {
        Text: "Textantwort",
        SingleChoice: "Einzelauswahl",
        MultiChoice: "Mehrfachauswahl",
        SingleChoiceWithOther: "Einzelauswahl + Andere",
        MultiChoiceWithOther: "Mehrfachauswahl + Andere",
      },
    },
  },
  PriceCategories: {
    Name: "Name",
    Type: "Typ",
    CommissionRate: "Provision",
    DefaultPrice: "Standardpreis",
    DateCreated: "Erstellungsdatum",
    DateUpdated: "Aktualisierungsdatum",
    SearchPlaceholder: "Name der Preiskategorie",
    PriceCategoryTypes: {
      PerMinute: "Pro Minute",
      PerJob: "Pro Job",
    },
    PriceSuffix: {
      PerMinute: "€/Min",
      PerJob: "€/Job",
      PerProject: "€/Projekt",
    },
    CreateModal: {
      Title: "Neue Preiskategorie erstellen",
      Name: "Name",
      NamePlaceholder: "Name der Preiskategorie eingeben",
      TypePlaceholder: "Preiskategorietyp auswählen",
      Create: "Erstellen",
      SuccessMessage: "Preiskategorie wurde erfolgreich erstellt",
      ErrorMessage: "Preiskategorie konnte nicht erstellt werden",
    },
    Detail: {
      BackToList: "Zurück zu Preiskategorien",
      Information: "Informationen",
      EditInformation: "Informationen bearbeiten",
      NotFound: "Preiskategorie wurde nicht gefunden",
      Activate: "Aktivieren",
      Deactivate: "Deaktivieren",
      ActivateSuccess: "Preiskategorie wurde erfolgreich aktiviert",
      DeactivateSuccess: "Preiskategorie wurde erfolgreich deaktiviert",
      StatusChangeError:
        "Status der Preiskategorie konnte nicht geändert werden",
    },
    EditModal: {
      Title: "Preiskategorie bearbeiten",
      Save: "Speichern",
      SuccessMessage: "Preiskategorie wurde erfolgreich aktualisiert",
      ErrorMessage: "Preiskategorie konnte nicht aktualisiert werden",
    },
  },
  Clients: {
    CompanyName: "Firmenname",
    Partner: "Partner",
    AllPartners: "Alle Partner",
    Email: "E-Mail",
    Phone: "Telefon",
    ProjectCount: "Anzahl Projekte",
    SearchClientsPlaceholder: "Kundenname, Partner...",
    CreateClientModal: {
      Title: "Neuen Kunden erstellen",
      CompanyName: "Firmenname",
      CompanyNamePlaceholder: "Firmenname eingeben",
      CompanyNumber: "Handelsregisternr.",
      CompanyNumberPlaceholder: "Handelsregisternr. eingeben",
      TaxNumber: "USt-IdNr.",
      TaxNumberPlaceholder: "USt-IdNr. eingeben",
      Email: "E-Mail",
      EmailPlaceholder: "E-Mail eingeben",
      Phone: "Telefon",
      PhonePlaceholder: "Telefonnummer eingeben",
      Address: "Adresse",
      AddressPlaceholder: "Adresse eingeben",
      City: "Stadt",
      CityPlaceholder: "Stadt eingeben",
      PostalCode: "PLZ",
      PostalCodePlaceholder: "PLZ eingeben (z.B. 12345)",
      Country: "Land",
      CountryPlaceholder: "Land auswählen",
      Create: "Erstellen",
      SuccessMessage: "Kunde wurde erfolgreich erstellt",
      ErrorMessage: "Kunde konnte nicht erstellt werden",
    },
    ClientDetail: {
      Information: "Informationen",
      EditInformation: "Informationen bearbeiten",
      CompanyName: "Firmenname",
      CompanyNumber: "Handelsregisternr.",
      TaxNumber: "USt-IdNr.",
      Email: "E-Mail",
      Phone: "Telefon",
      Address: "Adresse",
      City: "Stadt",
      PostalCode: "PLZ",
      State: "Land",
      Projects: "Projekte",
      NoProjects: "Keine Projekte",
      Contracts: "Verträge",
      NoContracts: "Keine Verträge",
      BackToClients: "Zurück zu Kunden",
      NotFound: "Kunde wurde nicht gefunden",
      Activate: "Aktivieren",
      Deactivate: "Deaktivieren",
      ActivateSuccess: "Kunde wurde erfolgreich aktiviert",
      DeactivateSuccess: "Kunde wurde erfolgreich deaktiviert",
      StatusChangeError: "Status des Kunden konnte nicht geändert werden",
    },
    EditClientModal: {
      Title: "Kunden bearbeiten",
      Save: "Speichern",
      SuccessMessage: "Kunde wurde erfolgreich aktualisiert",
      ErrorMessage: "Kunde konnte nicht aktualisiert werden",
    },
  },
  Users: {
    Login: "Login",
    Name: "Name",
    FirstName: "Vorname",
    LastName: "Nachname",
    SearchUsersPlaceholder: "Benutzer suchen...",
  },
  MusicAudio: {
    DisplayName: "Name",
    FileName: "Datei",
    Duration: "Dauer",
    DateCreated: "Erstellungsdatum",
    SearchPlaceholder: "Audiodateien suchen...",
    UploadModal: {
      Title: "Audiodatei hochladen",
      DisplayName: "Name",
      DisplayNamePlaceholder: "Dateiname",
      SelectFile: "Datei auswählen",
      Upload: "Hochladen",
      SuccessMessage: "Datei wurde erfolgreich hochgeladen",
      ErrorMessage: "Datei konnte nicht hochgeladen werden",
      LicenseConfirmation:
        "Mit dem Hochladen bestätige ich, dass ich die erforderlichen Rechte oder die Lizenz zur Nutzung dieser Audiodatei besitze.",
    },
    DeleteDialog: {
      Title: "Audiodatei löschen",
      Content: "Möchten Sie diese Audiodatei wirklich löschen?",
      Confirm: "Löschen",
      SuccessMessage: "Datei wurde erfolgreich gelöscht",
      ErrorMessage: "Datei konnte nicht gelöscht werden",
    },
    Download: "Herunterladen",
    DownloadError: "Datei konnte nicht heruntergeladen werden",
  },
  Billing: {
    CurrentBalance: "Aktueller Kontostand",
    TransactionHistory: "Transaktionsverlauf",
    Date: "Datum",
    Type: "Typ",
    Description: "Beschreibung",
    Amount: "Betrag",
    BalanceAfter: "Saldo danach",
    TransactionTypes: {
      Deposit: "Einzahlung",
      JobPayment: "Jobzahlung",
      Withdrawal: "Auszahlung",
      Reversal: "Stornierung",
      Adjustment: "Korrektur",
    },
    DepositModal: {
      Title: "Guthaben aufladen",
      Amount: "Betrag (EUR)",
      AmountPlaceholder: "Betrag eingeben",
      Description: "Beschreibung",
      DescriptionPlaceholder: "Optionale Beschreibung der Einzahlung",
      Confirm: "Zur Zahlung",
      SuccessMessage: "Weiterleitung zum Zahlungsanbieter...",
      ErrorMessage: "Zahlung konnte nicht eingeleitet werden",
    },
    InitiateDeposit: "Guthaben aufladen",
    AvailableFunds: "Verfügbare Mittel",
    Descriptions: {
      withdrawal: "Auszahlungsanfrage #{{withdrawalRequestID}}",
      jobPayment: "Zahlung für Job {{jobName}}, Projekt {{projectName}}",
      reversal: "Stornierte Transaktion: {{reason}}",
      reversalPayoutFailed: "Auszahlung fehlgeschlagen",
    },
  },
  Invoices: {
    Title: "Rechnungen",
    InvoiceNumber: "Rechnungsnr.",
    IssueDate: "Ausstellungsdatum",
    Type: "Typ",
    Seller: "Verkäufer",
    Buyer: "Käufer",
    TotalAmount: "Gesamtbetrag",
    Status: "Status",
    DownloadInvoice: "Rechnung herunterladen",
    DownloadError: "Rechnung konnte nicht heruntergeladen werden",
    SearchPlaceholder: "Rechnungen suchen...",
    Types: {
      Standard: "Rechnung",
      SelfBilling: "Gutschrift",
      CreditNote: "Gutschrift",
    },
    Statuses: {
      Issued: "Ausgestellt",
      Paid: "Bezahlt",
      Cancelled: "Storniert",
    },
  },
  WithdrawalApprovals: {
    ActorName: "Sprecher",
    Amount: "Betrag",
    Status: "Status",
    RequestedAt: "Beantragt am",
    IBAN: "IBAN",
    SWIFT: "SWIFT",
    ResolvedAt: "Bearbeitet am",
    ResolvedBy: "Bearbeitet von",
    ExpiresAt: "Gültig bis",
    ActorBalance: "Guthaben des Sprechers",
    EpcQrCode: "EPC QR-Code für Zahlung",
    CzechQrCode: "QR-Zahlung (CZ)",
    SearchPlaceholder: "Nach Sprechernamen suchen...",
    StatusPending: "Ausstehend",
    StatusApproved: "Genehmigt",
    StatusRejected: "Abgelehnt",
    StatusExpired: "Abgelaufen",
    Approve: "Genehmigen",
    Reject: "Ablehnen",
    RejectionReason: "Ablehnungsgrund",
    RejectionReasonPlaceholder: "Ablehnungsgrund eingeben...",
    ConfirmReject: "Ablehnung bestätigen",
    ApproveSuccess: "Auszahlung erfolgreich genehmigt",
    RejectSuccess: "Auszahlung abgelehnt",
    NotFound: "Auszahlungsantrag nicht gefunden",
  },
  Notifications: {
    Title: "Benachrichtigungen",
    Actions: "Aktionen",
    MarkAllAsRead: "Alle als gelesen markieren",
    DismissAll: "Alle verwerfen",
    Empty: "Keine Benachrichtigungen",
    SysAdmin_ActorWithdrawalRequested:
      "Sprecher {{actorName}} hat eine Auszahlung von {{amount}} EUR beantragt.",
    SysAdmin_PartnerRegistrationRequested:
      "Neue Partnerregistrierungsanfrage von {{contactName}} ({{companyName}}).",
    SysAdmin_ActorRegistrationRequested:
      "Neue Sprecherregistrierungsanfrage von {{actorName}} ({{email}}).",
    Partner_JobApprovedByActor:
      "Sprecher {{actorName}} hat die Aufgabe {{jobName}} im Projekt {{projectName}} genehmigt.",
    Partner_JobRejectedByActor:
      "Sprecher {{actorName}} hat die Aufgabe {{jobName}} im Projekt {{projectName}} abgelehnt.",
    RelativeTime: {
      JustNow: "Gerade eben",
      MinutesAgo: "vor {{count}} Min.",
      HoursAgo: "vor {{count}} Std.",
      DaysAgo: "vor {{count}} T.",
    },
  },
  RegistrationRequests: {
    Name: "Name",
    Type: "Typ",
    Status: "Status",
    Email: "E-Mail",
    Phone: "Telefon",
    Company: "Unternehmen",
    DateCreated: "Erstellungsdatum",
    SearchPlaceholder: "Anfragen suchen...",
    StatusPending: "Ausstehend",
    StatusResolved: "Erledigt",
    StatusApproved: "Genehmigt",
    StatusRejected: "Abgelehnt",
    TypePartner: "Partner",
    TypeActor: "Sprecher",
    AllStatuses: "Alle Status",
    AllTypes: "Alle Typen",
    Resolve: "Erledigen",
    ResolveSuccess: "Anfrage wurde erfolgreich erledigt.",
    NotFound: "Registrierungsanfrage nicht gefunden.",
    CreatePartner: "Partner erstellen",
    DetailTitle: "Registrierungsanfrage Detail",
    FirstName: "Vorname",
    LastName: "Nachname",
  },
  Reporting: {
    Title: "Berichte",
    RevenueThisMonth: "Umsatz diesen Monat",
    ActiveProjects: "Aktive Projekte",
    NewPartnersThisMonth: "Neue Partner diesen Monat",
    JobsThisMonth: "Jobs diesen Monat",
    RevenueOverTime: "Umsatz im Zeitverlauf",
    ProjectStatusDistribution: "Projektstatus-Verteilung",
    AverageCompletionTime: "Durchschnittliche Fertigstellungszeit",
    AverageJobCost: "Durchschnittliche Job-Kosten",
    AverageActorApprovalTime: "Durchschn. Genehmigungszeit",
    Days: "Tage",
    TopActorsByJobs: "Top-Schauspieler nach Jobs",
    TopActorsByEarnings: "Bestbezahlte Schauspieler",
    TopPartnersByProjects: "Partner mit den meisten Projekten",
    TopPartnersByJobs: "Partner mit den meisten Jobs",
    TopPartnersBySpend: "Partner mit den höchsten Ausgaben",
    AvgGenerationsPerJob: "Durchschnittliche Generierungen pro Job",
    VoiceModelUsageThisMonth: "Meistgenutzte KI-Modelle diesen Monat",
    JobStatusDistribution: "Job-Status-Verteilung",
    NoData: "Keine Daten verfügbar",
    Revenue: "Umsatz",
    Jobs: "Jobs",
    Earnings: "Einnahmen",
    PeriodAll: "Gesamter Zeitraum",
    PeriodThisMonth: "Diesen Monat",
    PeriodLast30Days: "Letzte 30 Tage",
    PeriodThisYear: "Dieses Jahr",
    PeriodLastYear: "Letztes Jahr",
  },
  Errors: {
    ApplicationError: {
      Title: "Ein Fehler ist aufgetreten",
      Subtitle: "Es tut uns leid, in der Anwendung ist ein Fehler aufgetreten.",
      Description:
        "Unsere Entwickler wurden benachrichtigt und arbeiten bereits an einer Lösung.",
      DebugHint: "Sind Sie Entwickler? Sehen Sie sich den Fehler an.",
      Home: "Startseite",
    },
    Error404: {
      Subtitle: "Seite wurde nicht gefunden",
      Home: "Startseite",
    },
    Error403: {
      Subtitle: "Sie haben keine Berechtigung, diese Seite anzuzeigen",
    },
    Error500: "Bei der Verarbeitung der Anfrage ist ein Fehler aufgetreten.",
    UserNotFound: "Benutzer nicht gefunden",
    PartnerNotFound: "Partner nicht gefunden",
  },
  SignIn: {
    Error: {
      General: "Ein Fehler ist aufgetreten",
      AccountIsDisabled: "Konto ist gesperrt",
      InvalidCredentials: "Ungültige Anmeldedaten",
      AccountWaitingForEmailConfirmation: "Konto wartet auf E-Mail-Bestätigung",
      ApplicationVerification: "Ungültige Anmeldedaten",
      InvalidToken: "Ungültiger Token",
      PhoneNumberNotFound: "Telefonnummer wurde nicht gefunden",
      SmsSendingFailed: "SMS-Versand fehlgeschlagen",
      InsufficientRole: "Benutzer mit dieser Rolle hat keine Berechtigung",
      AccountWaitingForSetPassword: "Konto wartet auf Passworteinrichtung",
    },
    Title: "Anmeldung",
    Subtitle:
      "Willkommen zurück! Geben Sie Ihre Anmeldedaten ein und setzen Sie Ihre Arbeit fort.",
    Username: {
      Label: "Benutzername",
    },
    Password: {
      Label: "Passwort",
    },
    DoNotHaveAccount: "Kein Konto?",
    ForgottenPassword: "Passwort vergessen?",
    RegisterNow: "Jetzt registrieren",
    Cookies: "Cookies",
    Help: "Hilfe",
    Button: "Anmelden",
  },
  SignUp: {
    Title: "Partnerregistrierung",
    Subtitle:
      "Füllen Sie das Registrierungsformular aus und wir werden Sie in Kürze mit dem Systemzugang kontaktieren.",
    FirstName: { Label: "Vorname" },
    LastName: { Label: "Nachname" },
    Company: { Label: "Firma" },
    Email: { Label: "E-Mail" },
    Phone: { Label: "Telefon" },
    TermsAndConditions:
      "Mit der Erstellung eines Kontos stimmen Sie den AI Connect",
    TermsLink: "Geschäftsbedingungen",
    Button: "Registrieren",
    AlreadyHaveAccount: "Haben Sie bereits ein Konto?",
    SignInNow: "Jetzt anmelden",
    RegistrationNote:
      "Die Registrierung von Sprechern erfolgt über Aufnahmesitzungen. Für weitere Informationen kontaktieren Sie unser",
    ProductionTeam: "Produktionsteam",
    Success: {
      Title: "Anfrage gesendet",
      Description:
        "Ihre Registrierungsanfrage wurde erfolgreich gesendet. Wir werden Sie unter der angegebenen E-Mail-Adresse kontaktieren.",
    },
    Error: {
      General: "Ein Fehler ist aufgetreten",
      UserExists: "Ein Konto mit dieser E-Mail-Adresse existiert bereits",
      DuplicateRequest:
        "Eine Registrierungsanfrage mit dieser E-Mail-Adresse wurde bereits gesendet",
      WeakPassword:
        "Das Passwort muss mindestens 8 Zeichen lang sein und mindestens einen Kleinbuchstaben, einen Großbuchstaben und eine Ziffer enthalten",
    },
  },
  RegisterActor: {
    Title: "Sprecherregistrierung",
    Subtitle:
      "Füllen Sie das Registrierungsformular aus und wir werden Sie in Kürze mit dem Systemzugang kontaktieren.",
    FirstName: { Label: "Vorname" },
    LastName: { Label: "Nachname" },
    Company: { Label: "Firma (optional)" },
    Email: { Label: "E-Mail" },
    Phone: { Label: "Telefon" },
    TermsAndConditions:
      "Mit der Erstellung eines Kontos stimmen Sie den AI Connect",
    TermsLink: "Geschäftsbedingungen",
    Button: "Registrieren",
    AlreadyHaveAccount: "Haben Sie bereits ein Konto?",
    SignInNow: "Jetzt anmelden",
    Success: {
      Title: "Anfrage gesendet",
      Description:
        "Ihre Registrierungsanfrage wurde erfolgreich gesendet. Wir werden Sie unter der angegebenen E-Mail-Adresse kontaktieren.",
    },
    Error: {
      General: "Ein Fehler ist aufgetreten",
      UserExists: "Ein Konto mit dieser E-Mail-Adresse existiert bereits",
      DuplicateRequest:
        "Eine Registrierungsanfrage mit dieser E-Mail-Adresse wurde bereits gesendet",
    },
  },
  Legal: {
    Body: "Dieses Dokument wird derzeit vorbereitet und in Kürze ergänzt. Vielen Dank für Ihre Geduld. Bei Fragen zur Verarbeitung personenbezogener Daten oder zu den Nutzungsbedingungen kontaktieren Sie uns bitte.",
    PrivacyPolicy: {
      Title: "Datenschutzerklärung",
    },
    TermsOfService: {
      Title: "Nutzungsbedingungen",
    },
  },
  Support: {
    Title: "Support & Hilfe",
    Body: "Die Support-Seite wird derzeit vorbereitet und in Kürze ergänzt. Wenn Sie Hilfe benötigen, kontaktieren Sie uns bitte per E-Mail – wir helfen Ihnen gerne weiter.",
  },
  Validation: {
    Required: "Pflichtfeld",
    InvalidEmail: "Ungültige E-Mail-Adresse",
    AlphabetsOnly: "Nur Buchstaben sind für dieses Feld erlaubt",
    DigitsOnly: "Darf nur Ziffern enthalten",
    InvalidPhone: "Ungültige Telefonnummer",
    InvalidFormat: "Ungültiges Format",
    InvalidBankAccount: "Ungültige Kontonummer",
    InvalidPersonalIdentificationNumber: "Ungültige Personalnummer",
    InvalidTaxNumber: "Ungültige USt-IdNr.",
    InvalidCompanyNumber: "Ungültige Handelsregisternr.",
    InvalidPostalCode: "Ungültiges PLZ-Format",
    IsTrue: "Muss angekreuzt sein",
    Number: {
      Integer: "Muss eine ganze Zahl sein",
      Min: "Der Wert darf nicht negativ sein",
      MoreThen: "Muss größer als 0 sein",
    },
    String: {
      Min: "Muss mindestens {{count}} Zeichen lang sein.",
      Max: "Darf nicht länger als {{count}} Zeichen sein.",
      StrictLength: "Muss genau {{count}} Zeichen enthalten",
      InvalidFormat: "Ungültiges Format",
    },
    Array: {
      Min: "Wählen Sie mindestens einen Eintrag aus.",
      Min_one: "Es muss mindestens {{count}} Eintrag ausgewählt werden.",
      Min_few: "Es müssen mindestens {{count}} Einträge ausgewählt werden.",
      Min_other: "Es müssen mindestens {{count}} Einträge ausgewählt werden.",
    },
    Date: {
      MustBeAfterStartDate: "Das Enddatum muss nach dem Startdatum liegen",
    },
  },
  SetPassword: {
    Title: "Passwort einrichten",
    Subtitle:
      "Legen Sie ein neues, sicheres Passwort fest, um Ihr Konto zu aktivieren oder Ihr Passwort zu ändern.",
    Password: { Label: "Passwort" },
    ConfirmPassword: { Label: "Passwort bestätigen" },
    Button: "Passwort einrichten",
    PasswordsMustMatch: "Passwörter müssen übereinstimmen",
    SuccessMessage:
      "Passwort wurde erfolgreich eingerichtet. Sie können sich jetzt anmelden.",
    Error: {
      General:
        "Der Link zum Zurücksetzen des Passworts ist ungültig oder abgelaufen. Bitte fordern Sie einen neuen Link an.",
      TokenNotFound: "Ungültiger Link",
      WeakPassword:
        "Das Passwort muss mindestens 8 Zeichen lang sein und mindestens einen Kleinbuchstaben, einen Großbuchstaben und eine Ziffer enthalten",
    },
  },
  ResetPassword: {
    Title: "Passwort zurücksetzen",
    Subtitle:
      "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen des Passworts.",
    Email: { Label: "E-Mail" },
    Button: "Link senden",
    BackToSignIn: "Zurück zur Anmeldung",
    Success: {
      Title: "Überprüfen Sie Ihre E-Mail",
      Description:
        "Falls die E-Mail-Adresse in unserem System existiert, wurde ein Link zum Zurücksetzen des Passworts gesendet.",
    },
  },
  BlDatePicker: {
    Locales: {
      One: "Tag",
      Two: "Tage",
      Few: "Tage",
      Other: "Tage",
      Many: "Tage",
      Zero: "Tage",
    },
    Placeholder: "Datum auswählen",
    Presets: {
      Today: "Heute",
      Yesterday: "Gestern",
      Last7Days: "Letzte 7 Tage",
      Last30Days: "Letzte 30 Tage",
      ThisMonth: "Dieser Monat",
      LastMonth: "Letzter Monat",
    },
  },
  Autocomplete: {
    ClearText: "Löschen",
    CloseText: "Schließen",
    OpenText: "Öffnen",
    NoOptionsText: "Keine Optionen",
    LoadingText: "Wird geladen...",
  },
  TextEditor: {
    Bold: "Fett",
    Italic: "Kursiv",
    Underline: "Unterstrichen",
    Strikethrough: "Durchgestrichen",
    Code: "Code",
    Paragraph: "Absatz",
    Heading1: "Überschrift 1",
    Heading2: "Überschrift 2",
    Heading3: "Überschrift 3",
    BulletList: "Aufzählungsliste",
    OrderedList: "Nummerierte Liste",
    Blockquote: "Zitat",
    CodeBlock: "Codeblock",
    HorizontalRule: "Horizontale Linie",
    Superscript: "Hochgestellt",
    Subscript: "Tiefgestellt",
    AlignLeft: "Linksbündig",
    AlignCenter: "Zentriert",
    AlignRight: "Rechtsbündig",
    AlignJustify: "Blocksatz",
    Highlight: "Hervorhebung",
  },
  Table: {
    NoData: "Keine Daten",
    NextPage: "Nächste Seite",
    PrevPage: "Vorherige Seite",
    RowsPerPage: "Zeilen pro Seite",
  },
  Documents: {
    SectionTitle: "Dokumente",
    UploadButton: "Dokument hochladen",
    ChooseFile: "Datei auswählen",
    DisplayNameLabel: "Dokumentname",
    UploadModalTitle: "Dokument hochladen",
    NoDocuments: "Keine Dokumente",
    DownloadError: "Dokument konnte nicht heruntergeladen werden",
    DeleteError: "Dokument konnte nicht gelöscht werden",
    UploadError: "Dokument konnte nicht hochgeladen werden",
  },
  ApiErrors: {
    General:
      "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    SearchExternalVoices: {
      General: "Stimmen konnten nicht gesucht werden.",
      UnsupportedVoiceLlm:
        "Das ausgewählte Sprachmodell wird nicht unterstützt.",
    },
    UploadUserProfilePicture: {
      General: "Profilbild konnte nicht hochgeladen werden.",
      UserNotFound: "Benutzer wurde nicht gefunden.",
      FileTooLarge: "Datei ist zu groß.",
      InvalidFileType: "Nicht unterstütztes Dateiformat.",
    },
    DeleteUserProfilePicture: {
      General: "Profilbild konnte nicht gelöscht werden.",
      UserNotFound: "Benutzer wurde nicht gefunden.",
    },
    DocumentUpload: {
      General: "Dokument konnte nicht hochgeladen werden.",
      EntityNotFound: "Entität wurde nicht gefunden.",
      FileTooLarge: "Datei ist zu groß.",
      InvalidFileType: "Nicht unterstütztes Dateiformat.",
    },
    SaveProject: {
      General: "Projekt konnte nicht gespeichert werden.",
      ClientNotFound: "Kunde wurde nicht gefunden.",
      ClientInactive: "Kunde ist deaktiviert.",
      ModuleNotFound: "Modul wurde nicht gefunden.",
      CurrentUserNotConnectWithPartner:
        "Ihr Konto ist mit keinem Partner verknüpft.",
      ProjectNotFound: "Projekt wurde nicht gefunden.",
      DuplicateExclusiveContractActor:
        "Derselbe Sprecher kann nicht mehrere Exklusivverträge in einem Projekt haben.",
      ExclusiveContractActorNotFound:
        "Sprecher für den Exklusivvertrag wurde nicht gefunden.",
      ExclusiveContractActorIndustryNotAllowed:
        "Sprecher für den Exklusivvertrag hat die Branche des Projekts nicht aktiviert.",
    },
    SyncProjectActors: {
      General: "Projektsprecher konnten nicht synchronisiert werden.",
      ProjectNotFound: "Projekt wurde nicht gefunden.",
      ActorsNotFound: "Sprecher wurde(n) nicht gefunden.",
      ActorPriceCategoryNotAllowed:
        "Preiskategorie des Sprechers ist nicht erlaubt.",
      ActorNotOpenToCollaboration:
        "Sprecher ist nicht offen für Zusammenarbeit.",
      TooManyActorsForSingleVoiceSpot:
        "Zu viele Sprecher für einen Einzelstimmen-Spot.",
      CannotChangeActorWithCompletedJobs:
        "Sprecher bei abgeschlossenen Jobs kann nicht geändert werden.",
      ActorIndustryNotAllowed:
        "Der Sprecher hat diese Branche nicht aktiviert.",
      CannotRemoveActorWithActiveJobs:
        "Sprecher mit abgeschlossenen oder ausstehenden Jobs kann nicht entfernt werden.",
    },
    SavePriceCategory: {
      General: "Preiskategorie konnte nicht gespeichert werden.",
      PriceCategoryNotFound: "Preiskategorie wurde nicht gefunden.",
      NameAlreadyExists:
        "Eine Preiskategorie mit diesem Namen existiert bereits.",
      CommissionRateOutOfRange:
        "Der Provisionssatz liegt außerhalb des erlaubten Bereichs.",
    },
    CreatePartnerMediaFile: {
      General: "Mediendatei konnte nicht hochgeladen werden.",
      FileTooLarge: "Datei ist zu groß.",
      InvalidFileType: "Nicht unterstütztes Dateiformat.",
      PartnerNotFound: "Partner wurde nicht gefunden.",
      LicenseNotConfirmed:
        "Sie müssen bestätigen, dass Sie die Lizenz für die Audiodatei besitzen, bevor Sie hochladen.",
    },
    TogglePartnerModule: {
      General: "Modulstatus konnte nicht geändert werden.",
      PartnerNotFound: "Partner wurde nicht gefunden.",
      ModuleNotFound: "Modul wurde nicht gefunden.",
      AlreadyEnabled: "Modul ist bereits aktiv.",
      AlreadyDisabled: "Modul ist bereits inaktiv.",
    },
    SetPartnerModules: {
      General: "Partnermodule konnten nicht gespeichert werden.",
      PartnerNotFound: "Partner wurde nicht gefunden.",
      ModuleNotFound: "Modul wurde nicht gefunden.",
    },
    SetModulePartners: {
      General: "Modulpartner konnten nicht gespeichert werden.",
      ModuleNotFound: "Modul wurde nicht gefunden.",
      PartnerNotFound: "Partner wurde nicht gefunden.",
    },
    SavePartner: {
      General: "Partner konnte nicht gespeichert werden.",
      ParentPartnerNotFound: "Übergeordneter Partner wurde nicht gefunden.",
      HierarchyTooDeep: "Partnerhierarchie ist zu tief.",
      CannotSetParentWithChildren:
        "Übergeordneter Partner kann nicht festgelegt werden, wenn der Partner untergeordnete Partner hat.",
      CannotBeSelfParent:
        "Ein Partner kann nicht sein eigener übergeordneter Partner sein.",
      UserWithLoginAlreadyExists:
        "Ein Benutzer mit dieser E-Mail-Adresse existiert bereits.",
    },
    SaveModule: {
      General: "Modul konnte nicht gespeichert werden.",
      PriceCategoryNotFound: "Preiskategorie wurde nicht gefunden.",
    },
    SaveModuleQuestions: {
      General: "Modulfragen konnten nicht gespeichert werden.",
      ModuleNotFound: "Modul wurde nicht gefunden.",
      InvalidQuestionConfiguration: "Ungültige Fragenkonfiguration.",
    },
    SaveJobAnswers: {
      General: "Antworten konnten nicht gespeichert werden.",
      JobNotFound: "Job wurde nicht gefunden.",
      MissingRequiredAnswer: "Antwort auf eine Pflichtfrage fehlt.",
      InvalidOption: "Ungültige ausgewählte Option.",
      InvalidQuestion: "Ungültige Frage.",
      TooManyOptionsForSingleChoice:
        "Bei einer Einfachauswahl-Frage kann nur eine Option ausgewählt werden.",
    },
    CreateJob: {
      General: "Job konnte nicht erstellt werden.",
      ProjectNotFound: "Projekt wurde nicht gefunden.",
      JobsLimitExceeded: "Das Joblimit des Projekts wurde überschritten.",
    },
    SaveJobScript: {
      General: "Skript konnte nicht gespeichert werden.",
      JobNotFound: "Job wurde nicht gefunden.",
    },
    GenerateVoicelines: {
      General: "Sprachzeilen konnten nicht generiert werden.",
      ProjectNotFound: "Projekt wurde nicht gefunden.",
      JobNotFound: "Job wurde nicht gefunden.",
      UnsupportedTextLlm: "Das ausgewählte Textmodell wird nicht unterstützt.",
      GenerationFailed:
        "Generierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
      RateLimited:
        "Der Textgenerierungsdienst ist vorübergehend überlastet oder das Anfragelimit wurde erreicht. Bitte versuchen Sie es in Kürze erneut.",
    },
    GenerateJobClip: {
      General: "Spot konnte nicht generiert werden.",
      JobNotFound: "Job wurde nicht gefunden.",
      ScriptNotFound: "Skript wurde nicht gefunden.",
      GenerationFailed:
        "Generierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
      ExclusiveContractJobLimitReached:
        "Das Auftragslimit des Exklusivvertrags für diesen Sprecher wurde erreicht.",
    },
    RetryFinalization: {
      General: "Job konnte nicht erneut finalisiert werden.",
      JobNotFound: "Job wurde nicht gefunden.",
      InvalidJobStatus:
        "Job befindet sich nicht im richtigen Status für diese Aktion.",
      NotAllApproved: "Nicht alle Sprachzeilen sind genehmigt.",
      InsufficientBalance: "Das Guthaben reicht nicht aus.",
      FinalizationFailed:
        "Finalisierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    },
    SubmitJob: {
      General: "Job konnte nicht eingereicht werden.",
      JobNotFound: "Job wurde nicht gefunden.",
      ClipNotFound: "Spot wurde nicht gefunden.",
      ClipNotFullType: "Der Spot ist nicht vom vollständigen Typ.",
      JobNotSubmittable:
        "Job befindet sich nicht in einem einreichbaren Status.",
      InsufficientBalance: "Das Guthaben reicht nicht aus.",
      FinalizationFailed:
        "Finalisierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    },
    GetFileDownloadUrl: {
      General: "Datei konnte nicht heruntergeladen werden.",
      FileNotFound: "Datei wurde nicht gefunden.",
    },
    SaveClient: {
      General: "Kunde konnte nicht gespeichert werden.",
      CompanyNumberAlreadyExists:
        "Ein Kunde mit dieser Handelsregisternummer existiert bereits.",
      UnauthorizedAccess: "Sie haben keine Berechtigung für diese Aktion.",
      PartnerRequired: "Für diese Aktion ist ein Partner erforderlich.",
    },
    InitiateDeposit: {
      General: "Zahlung konnte nicht eingeleitet werden.",
      PartnerRequired: "Für eine Einzahlung ist ein Partner erforderlich.",
      IdempotencyKeyRequired: "Transaktionskennzeichen fehlt.",
      InvalidAmount: "Der eingegebene Betrag ist ungültig.",
    },
    RegisterPartner: {
      General: "Registrierung fehlgeschlagen.",
      UserExists: "Ein Konto mit dieser E-Mail-Adresse existiert bereits.",
      DuplicateRequest:
        "Eine Registrierungsanfrage mit dieser E-Mail-Adresse wurde bereits gesendet.",
    },
    RegisterActor: {
      General: "Sprecherregistrierung fehlgeschlagen.",
      UserExists: "Ein Konto mit dieser E-Mail-Adresse existiert bereits.",
      DuplicateRequest:
        "Eine Registrierungsanfrage mit dieser E-Mail-Adresse wurde bereits gesendet.",
    },
    DetectAudioWatermark: {
      General: "Wasserzeichen konnte nicht erkannt werden.",
      InvalidFileType: "Nicht unterstütztes Dateiformat.",
      UnsupportedAudioFormat: "Nicht unterstütztes Audioformat.",
    },
    SaveActorPriceCategories: {
      General:
        "Preiskategorien des Sprechers konnten nicht gespeichert werden.",
      PriceCategoryNotFound: "Preiskategorie wurde nicht gefunden.",
    },
    SaveActor: {
      General: "Sprecher konnte nicht gespeichert werden.",
      EmailAlreadyExists:
        "Ein Sprecher mit dieser E-Mail-Adresse existiert bereits.",
      ActorAlreadyExists: "Sprecher existiert bereits.",
      PartnerRequired: "Für diese Aktion ist ein Partner erforderlich.",
    },
    SaveActorVoice: {
      General: "Sprecherstimme konnte nicht gespeichert werden.",
      ActorNotFound: "Sprecher wurde nicht gefunden.",
      ExternalVoiceIDEmpty: "Externe Stimm-ID darf nicht leer sein.",
      ActorVoiceNotFound: "Sprecherstimme wurde nicht gefunden.",
      TrainingTypeNotSupportedForVoiceLlm:
        "Dieser Trainingstyp wird vom ausgewählten Modell nicht unterstützt.",
      CannotChangeVoiceConfigAfterDraft:
        "Stimmkonfiguration kann nach dem Verlassen des Entwurfsstatus nicht mehr geändert werden.",
    },
    UploadActorVoiceTrainingFile: {
      General: "Trainingsdatei konnte nicht hochgeladen werden.",
      FileTooLarge: "Datei ist zu groß.",
      InvalidFileType: "Nicht unterstütztes Dateiformat.",
      ActorVoiceNotFound: "Sprecherstimme wurde nicht gefunden.",
      MaxFilesExceeded:
        "Maximale Anzahl an Trainingsdateien wurde überschritten.",
      ThisVoiceModelCannotBeTrained:
        "Dieses Sprachmodell kann nicht trainiert werden.",
      DuplicateFile: "Diese Datei wurde bereits hochgeladen.",
      CaptchaFileAlreadyExists: "Captcha-Datei existiert bereits.",
      CaptchaFileNotAllowedForInstant:
        "Captcha-Datei ist für Instant-Training nicht erlaubt.",
    },
    DeleteActorVoiceTrainingFile: {
      General: "Trainingsdatei konnte nicht gelöscht werden.",
      TrainingFileNotFound: "Trainingsdatei wurde nicht gefunden.",
      WrongStatus:
        "Sprecherstimme befindet sich nicht im richtigen Status für diese Aktion.",
    },
    DeleteAllActorVoiceTrainingFiles: {
      General: "Trainingsdateien konnten nicht gelöscht werden.",
      ActorVoiceNotFound: "Sprecherstimme wurde nicht gefunden.",
      WrongStatus:
        "Sprecherstimme befindet sich nicht im richtigen Status für diese Aktion.",
    },
    GenerateActorVoicePreview: {
      General: "Stimmvorschau konnte nicht generiert werden.",
      ActorVoiceNotFound: "Sprecherstimme wurde nicht gefunden.",
      WrongStatus:
        "Sprecherstimme befindet sich nicht im richtigen Status für diese Aktion.",
      InvalidParameters: "Ungültige Parameter für die Vorschaugenerierung.",
      GenerationFailed:
        "Vorschaugenerierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    },
    TrainingActorVoice: {
      General: "Stimmtraining konnte nicht gestartet werden.",
      LlmModelNotSupportCustomTraining:
        "Das ausgewählte Modell unterstützt kein benutzerdefiniertes Training.",
      TrainingFilesEmpty: "Keine Trainingsdateien hochgeladen.",
      ActorVoiceNotFound: "Sprecherstimme wurde nicht gefunden.",
      WrongStatus:
        "Sprecherstimme befindet sich nicht im richtigen Status für diese Aktion.",
      CaptchaFileRequired: "Captcha-Datei ist erforderlich.",
      InsufficientAudioDuration: "Die Gesamtdauer der Aufnahmen ist zu kurz.",
    },
    ApproveWithdrawal: {
      General: "Auszahlung konnte nicht genehmigt werden.",
      NotFound: "Auszahlungsantrag nicht gefunden.",
      AlreadyProcessed: "Dieser Antrag wurde bereits bearbeitet.",
      Expired: "Der Antrag ist abgelaufen.",
      LedgerError: "Fehler bei der Zahlungsverarbeitung.",
    },
    RejectWithdrawal: {
      General: "Auszahlung konnte nicht abgelehnt werden.",
      NotFound: "Auszahlungsantrag nicht gefunden.",
      AlreadyProcessed: "Dieser Antrag wurde bereits bearbeitet.",
    },
    ResolveRegistrationRequest: {
      General: "Registrierungsanfrage konnte nicht erledigt werden.",
      NotFound: "Registrierungsanfrage nicht gefunden.",
      AlreadyResolved: "Diese Anfrage wurde bereits erledigt.",
    },
  },
} satisfies ResourceDictionary;
